module.exports = __webpack_public_path__ + "img/guohui.eaf6b219.png";